import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import UserByIdContainer from "../../Componant/organisms/UserById";

type Props = {};

function UserById({}: Props) {
  const { userId } = useParams();

  return (
    <div className="page-body">
      {userId ? (
        <UserByIdContainer id={userId} />
      ) : (
        <Row>
          <Col className="d-flex justify-content-center">User Id Not Found</Col>
        </Row>
      )}
    </div>
  );
}

export default UserById;
